module.exports = __webpack_public_path__ + "static/media/OpenMundo.d95f50bf.png";